<template>
    <rkm-modal
        persistent
        ref="RkmModal"
        title="Destino"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.destino.unidades"
                        :validations="validations.unidade"
                        @change="handleUnidadeChange"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="data.model.destino.unidadeId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.destino.infraestruturas"
                        :validations="validations.infraestrutura"
                        @change="handleInfraestruturaChange"
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="data.model.destino.infraestruturaId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.destino.ocupacoes"
                        :validations="validations.ocupacao"
                        @change="handleOcupacaoChange"
                        label="CBO"
                        show-default-option
                        text-field="descricao"
                        v-model="data.model.destino.ocupacaoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.destino.especialidades"
                        :validations="validations.especialidade"
                        @change="handleEspecialidadeChange"
                        label="Especialidade"
                        show-default-option
                        text-field="nome"
                        v-model="data.model.destino.especialidadeId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.destino.usuarios"
                        :validations="validations.usuario"
                        label="Profissional"
                        show-default-option
                        text-field="nome"
                        v-model="data.model.destino.usuarioId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                @click="reschedule"
                color="primary"
            >
                Continuar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                unidade: {required: true},
                infraestrutura: {required: true},
                ocupacao: {required: true},
                especialidade: {required: true},
                usuario: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            gerenciamentoMedico: this.getConectaSusRepository('ambulatorio.gerenciamentoMedico'),
        }
    },
    data: () => ({
        date: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(date) {
            this.reset()

            this.date = date

            this.$refs.RkmModal.show()

            this.getUnidades()
        },
        handleUnidadeChange(value) {
            this.data.form.destino.infraestruturas = []
            this.data.form.destino.ocupacoes = []
            this.data.form.destino.especialidades = []
            this.data.form.destino.usuarios = []
            this.data.model.destino.infraestruturaId = null
            this.data.model.destino.ocupacaoId = null
            this.data.model.destino.especialidadeId = null
            this.data.model.destino.usuarioId = null

            if (value === null) return

            this.getInfraestruturas(value)
        },
        handleInfraestruturaChange(value) {
            this.data.form.destino.ocupacoes = []
            this.data.form.destino.especialidades = []
            this.data.form.destino.usuarios = []
            this.data.model.destino.ocupacaoId = null
            this.data.model.destino.especialidadeId = null
            this.data.model.destino.usuarioId = null

            if (value === null) return

            this.getOcupacoes(value)
        },
        handleOcupacaoChange(value) {
            this.data.form.destino.especialidades = []
            this.data.form.destino.usuarios = []
            this.data.model.destino.especialidadeId = null
            this.data.model.destino.usuarioId = null

            if (value === null) return

            this.getEspecialidades(this.data.model.destino.infraestruturaId, value)
        },
        handleEspecialidadeChange(value) {
            if (value === null) return

            this.getUsuarios(this.data.model.destino.infraestruturaId, value)
        },
        async getUnidades() {
            const request = {
                origem: 'destino',
                listar: 'unidades',
            }

            this.setLoading()

            try {
                const response = await this.repositories.gerenciamentoMedico.list(this.camelObjectKeysToSnakeRecursive(request))

                this.data.form.destino.unidades = Object.assign(response.data.unidades)

                if (this.data.form.destino.unidades.length === 1) {
                    const selected = this.data.form.destino.unidades[0]
                    this.data.model.destino.unidadeId = selected.id

                    this.getInfraestruturas(this.data.model.destino.unidadeId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getInfraestruturas(unidadeId) {
            const request = {
                origem: 'destino',
                listar: 'infraestruturas',
                unidadeId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.gerenciamentoMedico.list(this.camelObjectKeysToSnakeRecursive(request))

                this.data.form.destino.infraestruturas = Object.assign(response.data.infraestruturas)

                if (this.data.form.destino.infraestruturas.length === 1) {
                    const selected = this.data.form.destino.infraestruturas[0]
                    this.data.model.destino.infraestruturaId = selected.id

                    this.getOcupacoes(this.data.model.destino.infraestruturaId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getOcupacoes(infraestruturaId) {
            const request = {
                origem: 'destino',
                listar: 'ocupacoes',
                infraestruturaId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.gerenciamentoMedico.list(this.camelObjectKeysToSnakeRecursive(request))

                this.data.form.destino.ocupacoes = Object.assign(response.data.ocupacoes)

                if (this.data.form.destino.ocupacoes.length === 1) {
                    const selected = this.data.form.destino.ocupacoes[0]
                    this.data.model.destino.ocupacaoId = selected.id

                    this.getEspecialidades(infraestruturaId, this.data.model.destino.ocupacaoId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getEspecialidades(infraestruturaId, ocupacaoId) {
            const request = {
                origem: 'destino',
                listar: 'especialidades',
                infraestruturaId,
                ocupacaoId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.gerenciamentoMedico.list(this.camelObjectKeysToSnakeRecursive(request))

                this.data.form.destino.especialidades = Object.assign(response.data.especialidades)

                if (this.data.form.destino.especialidades.length === 1) {
                    const selected = this.data.form.destino.especialidades[0]
                    this.data.model.destino.especialidadeId = selected.id

                    this.getUsuarios(infraestruturaId, this.data.model.destino.especialidadeId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getUsuarios(infraestruturaId, especialidadeId) {
            const request = {
                origem: 'destino',
                listar: 'usuarios',
                infraestruturaId,
                especialidadeId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.gerenciamentoMedico.list(this.camelObjectKeysToSnakeRecursive(request))

                this.data.form.destino.usuarios = Object.assign(response.data.usuarios)

                if (this.data.form.destino.usuarios.length === 1) {
                    const selected = this.data.form.destino.usuarios[0]
                    this.data.model.destino.usuarioId = selected.id
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        reschedule() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.$refs.RkmModal.hide()
                    this.$emit('reschedule', this.date)
                })
        },
        reset() {
            this.data.form.destino.unidades = []
            this.data.form.destino.infraestruturas = []
            this.data.form.destino.ocupacoes = []
            this.data.form.destino.especialidades = []
            this.data.form.destino.usuarios = []
            this.data.model.destino.unidadeId = null
            this.data.model.destino.infraestruturaId = null
            this.data.model.destino.ocupacaoId = null
            this.data.model.destino.especialidadeId = null
            this.data.model.destino.usuarioId = null
        },
    },
    mixins: [error, repository, stringCase],
    props: {
        data: {type: Object, required: true},
    },
}
</script>